import React from 'react'
import "./Who_We_Are.css"

function Who_We_Are() {
    return (
        <>
            <section className='Who_We_Are margin_section'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-6">
                            <div className="heading_content_holder">
                                <h3>Who We Are</h3>
                                <p>We're a team of tech enthusiasts, finance professionals, and everyday renters people who understand the real struggles of monthly payments. That’s why we’ve built this app to serve real needs with simplicity, security and support at its core.</p>
                            </div>
                            <div className="content_holder">
                                <h4>Our Mission</h4>
                                <p>To simplify rental and utility payments for every household and empower users to take control of their monthly dues all from their smartphone</p>
                            </div>
                        </div>

                        <div className="col-md-6 col-sm-6">
                            <div className="img_holder">
                                <img src={"/assets/images/about/who-we-are/img_1.png"} alt="icon" className="who_we_are_img" />
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Who_We_Are